import { FaAngleRight } from "react-icons/fa6";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { Link } from "react-router-dom";
import VendorTable from "./RestaurantMgt/VendorTable";
import { useState } from "react";
import { GoPencil } from "react-icons/go";
import OrderAndMenuTable from "./OrderAndMenuTable";

const orderNavData = [
  {
    title: "Active Orders",
    amount: 23,
  },
  {
    title: "Delayed Orders",
    amount: 23,
  },
  {
    title: "Delivered Today",
    amount: 23,
  },
  {
    title: "Average Delivery Time",
    amount: 23,
  },
];
const Index = () => {
  const [activeTab, setActiveTab] = useState("management");

  return (
    <section className="font-mont">
      <div className="flex items-start gap-4">
        <Link to="/dashboard/restaurants">
          <button className="cursor-pointer p-2 rounded-full bg-[#008B5014]">
            <MdOutlineKeyboardBackspace className="w-6 h-6" />
          </button>
        </Link>
        <article>
          <h1 className="text-2xl font-medium mb-2 inline-flex items-center gap-3">
            <span className="font-semibold">Restaurant</span> <FaAngleRight />
            {activeTab === "management"
              ? "Restaurant Management"
              : activeTab === "orders"
              ? "Order Monitoring"
              : "Menu Oversight"}
          </h1>
          <p className="text-sm">
            {activeTab === "management"
              ? "Overview of FoodBank Restaurant platform operations and key metrics."
              : activeTab === "orders"
              ? "Track and manage orders across all vendors in real-time."
              : "Review and manage vendor menu items and promotional content."}
          </p>
        </article>
      </div>
      <section className="bg-[#EEEEEE40] px-3 py-5 my-3">
        <nav className="bg-white p-5 w-fit">
          <ul className="flex gap-10 text-base font-medium">
            {
              <li>
                <button
                  type="button"
                  className={`cursor-pointer p-2 ${
                    activeTab === "management" && "bg-[#EEEEEE40]"
                  }`}
                  onClick={() => setActiveTab("management")}
                >
                  Restaurant Management
                </button>
              </li>
            }
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "orders" && "bg-[#EEEEEE40]"
                }`}
                onClick={() => setActiveTab("orders")}
              >
                Order Monitoring
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`cursor-pointer p-2 ${
                  activeTab === "menu" && "bg-[#EEEEEE40]"
                }`}
                onClick={() => setActiveTab("menu")}
              >
                Menu Oversight
              </button>
            </li>
          </ul>
        </nav>
        <section>
          {activeTab === "management" ? (
            <p className="text-[10px] text-secondary py-4">
              *Manage vendor onboarding, approvals, and account status.
            </p>
          ) : activeTab === "orders" ? (
            <article className="bg-white px-4 py-7 my-5 flex items-center gap-3 justify-between">
              {orderNavData.map((item) => (
                <div
                  key={item.title}
                  className="w-64 border rounded-md py-3 px-5"
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm">{item.title}</h3>
                    <div className="p-3 rounded-full border">
                      <GoPencil className="w-3 h-3" />
                    </div>
                  </div>
                  <p className="text-lg font-medium">{item.amount}</p>
                </div>
              ))}
            </article>
          ) : null}
        </section>
        <>
          {activeTab === "management" ? (
            <VendorTable />
          ) : activeTab === "orders" ? (
            <OrderAndMenuTable table="orders" />
          ) : activeTab === "menu" ? (
            <OrderAndMenuTable table="menu" />
          ) : null}
        </>
      </section>
    </section>
  );
};

export default Index;
